import type { LocalizedHref } from "./types";

export type LocaleOptions = { defaultLang: string };

// The one place that knows the default language has no URL prefix.
export const localePrefix = (
  lang: string,
  { defaultLang }: LocaleOptions,
): string => (lang === defaultLang ? "" : `/${lang}`);

export const localizePath = (
  path: string,
  lang: string,
  options: LocaleOptions,
): LocalizedHref => {
  const prefix = localePrefix(lang, options);
  const rest = path === "/" ? "" : path;
  return (`${prefix}${rest}` || "/") as LocalizedHref;
};

export const splitLocale = (
  pathname: string,
  locales: readonly string[],
): { lang?: string; path: string } => {
  const [first, ...rest] = pathname.split("/").filter(Boolean);
  if (first !== undefined && locales.includes(first)) {
    return { lang: first, path: `/${rest.join("/")}` };
  }
  return { path: pathname };
};

export const switchLanguage = (
  href: string,
  lang: string,
  options: LocaleOptions & { locales: readonly string[] },
): LocalizedHref => {
  const url = new URL(href, "http://localhost");
  const { path } = splitLocale(url.pathname, options.locales);
  return `${localizePath(path, lang, options)}${url.search}${url.hash}` as LocalizedHref;
};
